module.exports = __webpack_public_path__ + "img/1 (40).395b2d64.png";